export default defineNuxtRouteMiddleware((to) => {
  const { $localePath } = useNuxtApp()
  const id = to.params.id
  const parsedId = Number(id)

  if (!id || isNaN(parsedId)) return navigateTo($localePath('/'))
})
